import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { WatchPage } from "./routes/WatchPage";
import { DisplayPage } from "./routes/DisplayPage";
import { AdminWebinarsPage } from "./routes/AdminWebinarsPage";
import { AdminQuestionsPage } from "./routes/AdminQuestionsPage";
import { AdminLeadsPage } from "./routes/AdminLeadsPage";
import { AdminSettingsPage } from "./routes/AdminSettingsPage";
import "./styles.css";

const router = createBrowserRouter([
  { path: "/webinars/:slug/watch", element: <WatchPage /> },
  { path: "/webinars/:slug/display", element: <DisplayPage /> },
  { path: "/admin/webinars", element: <AdminWebinarsPage /> },
  { path: "/admin/webinars/:webinarId/questions", element: <AdminQuestionsPage /> },
  { path: "/admin/webinars/:webinarId/leads", element: <AdminLeadsPage /> },
  { path: "/admin/settings", element: <AdminSettingsPage /> },
  { path: "*", element: <NotFound /> },
]);

function NotFound() {
  return (
    <div className="centered-message">
      <h1>ページが見つかりません</h1>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
